import { Action } from '@ngrx/store';

export enum PaymentTermsActionTypes {
  LOAD_PAYMENT_TERMS_VALUES = '[Payment terms] Load payment terms',
  LOAD_PAYMENT_TERMS_VALUES_SUCCESS = '[Payment terms] Load payment terms success',
  LOAD_PAYMENT_TERMS_VALUES_ERROR = '[Payment terms] Load payment terms success',
}

export class LoadPaymentTermsValues implements Action {
  readonly type = PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES;

  constructor(public payload: any) {}
}

export class LoadPaymentTermsSuccess implements Action {
  readonly type = PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES_SUCCESS;

  constructor(public payload: any) {}
}

export class LoadPaymentTermsError implements Action {
  readonly type = PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES_ERROR;

  constructor(public payload: any) {}
}

export type PaymentTermsActions = LoadPaymentTermsValues | LoadPaymentTermsSuccess | LoadPaymentTermsError;
